import { render, staticRenderFns } from "./freeResponseQuestion.vue?vue&type=template&id=72f72902&scoped=true&"
import script from "./freeResponseQuestion.vue?vue&type=script&lang=js&"
export * from "./freeResponseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./freeResponseQuestion.vue?vue&type=style&index=0&id=72f72902&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f72902",
  null
  
)

export default component.exports